export const CLEAR_LOADING = 'CLEAR_LOADING'
